<template>
  <div class="pipedrive-frame pa-4 d-flex justify-center align-center flex-column">
    <div class="w-100" v-if="loading">
      <!-- <v-img :src="require('@/assets/images/loading.png')"></v-img>
      <v-progress-circular class="ai-logo" indeterminate color="white" :size="80"></v-progress-circular> -->
      <v-skeleton-loader type="paragraph, paragraph, paragraph"></v-skeleton-loader>
    </div>

    <div class="d-flex flex-column justify-center align-center" v-else>
      <SummaryHeader />
      <SummaryCard class="mb-4" v-for="(card, index) in summaryItens" :key="index" :card="card" />

      <v-btn @click="openModal" color="primary" elevation="0" width="176px" height="35px">
        <span class="font-weight-medium" style="letter-spacing: 0px;">Ver mais detalhes</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import AppExtensionsSDK, { Command, Modal } from '@pipedrive/app-extensions-sdk';

import { ref, onMounted, computed } from 'vue'
import { pipedriveApi } from '../services/pipedriveApi'

import moment from "moment";
import 'moment/dist/locale/pt-br';

import { usePipedriveStore } from '../composables/use-pipedrive-store'

moment.locale("pt-br");

import { getCurrentInstance } from 'vue'

import SummaryCard from './SummaryCard.vue'
import SummaryHeader from './SummaryHeader.vue';

export default {
  name: 'PipedriveFrame',
  components: {
    SummaryCard,
    SummaryHeader
  },
  props: {
    dealId: {
      type: String,
      required: false
    },
    token: {
      type: String,
      required: true
    }
  },
  setup(props, { root }) {
    const app = getCurrentInstance()
    let sdk = null;
    //TODO: obter contexto do pipe, pegar deal id
    const { loadRealEstateOrderSummary } = usePipedriveStore(app.root);

    const pipedriveFrame = ref(false)
    const frameUrl = ref(null)
    const loading = ref(true)
    const error = ref(null)
    const orderID = ref(null)
    const iframeReady = ref(false)
    const customFieldId = ref(null)

    const getCurrentDate = computed(() => {
      return moment().format("dddd, DD/MM/YYYY")
    })

    const findOrderIDFieldId = async () => {
      try {
        const fields = await pipedriveApi.getCustomFields(props.token)
        const orderIDField = fields.find(field => field.name.toLowerCase() === 'orderid')
        if (orderIDField) {
          customFieldId.value = orderIDField.key
          return orderIDField.key
        }
        throw new Error('Campo orderID não encontrado')
      } catch (err) {
        throw new Error('Erro ao buscar custom fields')
      }
    }

    const getOrderIDValue = async (dealId) => {
      try {
        const fieldId = await findOrderIDFieldId()
        const deal = await pipedriveApi.getDealCustomField(dealId, props.token)
        if (deal && deal[fieldId]) {
          orderID.value = deal[fieldId]
        } else {
          throw new Error('OrderID não encontrado para este deal')
        }
      } catch (err) {
        throw err
      }
    }

    const initializeSdk = async () => {
      try {
        loading.value = true
        // SDK detects identifier from URL and uses default custom UI size
        const app = new AppExtensionsSDK({ size: { height: 100 } });

        if (!app) {
          throw new Error('ExtensionSDK não está disponível ou não contém o método initialize')
        }

        sdk = await app.initialize({
          clientId: process.env.VUE_APP_PIPEDRIVE_CLIENT_ID, // Certifique-se de configurar no .env
          identifier: "ddbdbf8e-c8d3-42ec-a1c7-4fc9f2ee56e3",
          size: { height: 500 }
        })

        iframeReady.value = true
      } catch (err) {
        console.error('Erro ao inicializar SDK:', err)
        error.value = 'Erro ao inicializar integração com Pipedrive'
      }
    }

    const loadSummary = async () => {
      try {
        const data = await loadRealEstateOrderSummary(1);
        summaryItens.value = [data];
        console.log("data", data)
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => {
      try {
        await initializeSdk()
        await loadSummary()
      } catch (err) {
        error.value = err.message
      }
    })

    const openModal = async () => {
      await sdk.execute(Command.OPEN_MODAL, {
        type: Modal.CUSTOM_MODAL,
        action_id: "ddbdbf8e-c8d3-42ec-a1c7-4fc9f2ee56e3",
        data: {
          item: 'xyz',
        },
        size: { height: 700, width: 1000 }
      });
    }

    const summaryItens = ref([]);

    return {
      pipedriveFrame,
      frameUrl,
      loading,
      error,
      orderID,
      iframeReady,
      openModal,
      summaryItens,
      getCurrentDate
    }
  }
}
</script>

<style scoped>
.pipedrive-frame {
  position: relative;
  width: 100%;
}

.loading,
.error {
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 10px;
}

.error {
  color: #dc3545;
  background-color: #f8d7da;
}

.order-info {
  padding: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  margin-bottom: 10px;
}

iframe {
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 700px;
}

::v-deep .AppExtensions__themePanel__koi {
  height: 700px;
}

.ai-logo {
  position: absolute;
  top: 150px;
  left: 150px;
}
</style>
